import { FC, useContext, useEffect, useState } from 'react';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import Brand from '../../../layout/Brand/Brand';
import Navigation from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { getFilteredDashboardNavigationMenu } from '../../../menu'; // Import the new function

const DefaultAside: FC = () => {
  const { asideStatus, setAsideStatus } = useContext(ThemeContext);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [navigationMenu, setNavigationMenu] = useState({}); // State to hold the filtered menu

  useEffect(() => {
    // Retrieve user role from localStorage
    const storedUserRole = localStorage.getItem("userRole");
    setUserRole(storedUserRole);
  }, []);

  useEffect(() => {
    // Update the navigation menu whenever the userRole changes
    setNavigationMenu(getFilteredDashboardNavigationMenu(userRole));
  }, [userRole]); // Re-run when userRole changes

  return (
    <Aside>
      <AsideHead>
        <Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
      </AsideHead>
      <AsideBody>
        {/* Pass the dynamically filtered menu to your Navigation component */}
        <Navigation menu={navigationMenu} id='main-navigation' />
      </AsideBody>
      <AsideFoot>
        <User />
      </AsideFoot>
    </Aside>
  );
};

export default DefaultAside;